(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "@htmniseko/htm-helpers/url/getUrlQuery"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("@htmniseko/htm-helpers/url/getUrlQuery"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.React, global.getUrlQuery);
    global.Facet = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _getUrlQuery) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = facetFactory;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _getUrlQuery = _interopRequireDefault(_getUrlQuery);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
  function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
  function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
  function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
  function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
  function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  /*
    Higher Order Component that adds filtering functionality for the wrapped component.
  
    Initializing: Currently it's easiest to create small wrapper for this:
        import { default as FacetHoc } from '@htmniseko/htm-components'
  
        @connect(state => ({ filters: state.facets.filters, location: state.routing.locationBeforeTransitions }), { push, toggleFilter })
        class Facet extends Component {
          render() {
            return (
              <FacetHoc {...this.props}
            )
          }
        }
  
    Example usage #1
        @facet('attributeName')
        export default class MyFacet extends Component {
  
    Example usage #2: Define attribute dynamically
        @facet(null)
        export default class MyFacet extends Component {
    then in another component
        <MyComponent attribute="dynamicAttributeName" />
  
    Example usage #3: Read and set multiple values from one Facet
        @facet(['attribute1', 'attribute2'])
        export default class MyFacet extends Component {
          ...
          this.props.applyFilters([value1, value2])
  
    Example usage #3: You can also use this class just to perform the search
        @facet()
        export default class MyFacet extends Component {
            render() {
                <button onClick={this.props.doSearch}>Search</button>
            }
        }
  */
  function facetFactory(wrappedAttribute) {
    return function facet(WrappedComponent) {
      var _Facet;
      // TODO Handle undefined attributes gracefully; happens when using this class only to search
      return _Facet = /*#__PURE__*/function (_PureComponent) {
        function Facet() {
          _classCallCheck(this, Facet);
          return _callSuper(this, Facet, arguments);
        }
        _inherits(Facet, _PureComponent);
        return _createClass(Facet, [{
          key: "componentDidMount",
          value:
          // On server-side; Read the location query for this attribute and set it to initial filters
          // By doing this here, each child Facet do not need to worry about setting this
          function componentDidMount() {
            var location = this.props.location;
            this.matchFiltersToLocation(location);
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(prevProps) {
            var location = this.props.location;
            // If location was changed by external force (e.g. reset filters link, back/forward buttons),
            // we should update the filters
            if (prevProps.location.key !== location.key) {
              this.matchFiltersToLocation(location);
            }
          }

          /**
           * This is required because in React Router 4+, there is no `query` available in location
           * instead we have `search` in its place. This getter returns the `query` object.
           */
        }, {
          key: "query",
          get: function get() {
            var location = this.props.location;
            return (0, _getUrlQuery["default"])(location);
          }

          // Initial value for single attribute facet is a string
          // For array-type it's an object with key for each attribute and value matching the attribute
        }, {
          key: "getInitialValue",
          value: function getInitialValue() {
            var _this$props = this.props,
              attribute = _this$props.attribute,
              location = _this$props.location;
            var attr = wrappedAttribute || attribute;
            // For backward compatibility, in the case where `query` is undefined
            var query = location.query || this.query;
            if (Array.isArray(attr)) {
              var result = {};
              attr.forEach(function (key) {
                result[key] = query[key];
              });
              return result;
            }
            return query[attr];
          }

          // Search by combining all the filters into an URL query and pushing it to URL
        }, {
          key: "doSearch",
          value: function doSearch() {
            var defaultFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var baseURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
            var _this$props2 = this.props,
              filters = _this$props2.filters,
              push = _this$props2.push;
            var searchFilters = _objectSpread(_objectSpread({}, filters), defaultFilters);
            var searchParams = Object.keys(searchFilters).map(function (key) {
              return "".concat(key, "=").concat(searchFilters[key]);
            });
            push("".concat(baseURL, "?").concat(searchParams.join('&')));
          }
        }, {
          key: "applyFilter",
          value: function applyFilter(values, searchNow, baseURL) {
            var _this$props3 = this.props,
              attribute = _this$props3.attribute,
              toggleFilter = _this$props3.toggleFilter;
            var attr = wrappedAttribute || attribute;
            attr = Array.isArray(attr) ? attr : [attr];
            var temporaryFilters = {};
            attr.forEach(function (key, i) {
              if (!values) {
                toggleFilter(key, null);
                return;
              }
              // When value, read the value for each attribute key and set filter
              var value = Array.isArray(values) ? values[i] : values;
              toggleFilter(key, value);
              temporaryFilters[key] = value;
            });
            if (searchNow) {
              this.doSearch(temporaryFilters, baseURL);
            }
          }

          // When changing filters and searching, location and filters will match
          // However, when URL was changed without the filters changing, they will be out-of-sync
          // In that case, we update the filters to match the URL
        }, {
          key: "matchFiltersToLocation",
          value: function matchFiltersToLocation(location) {
            var _this$props4 = this.props,
              attribute = _this$props4.attribute,
              toggleFilter = _this$props4.toggleFilter;
            var attr = wrappedAttribute || attribute;
            attr = Array.isArray(attr) ? attr : [attr];
            var query = location.query || this.query;
            attr.forEach(function (key) {
              // Update all the filters to match the URL query, there can be values or not
              var urlValue = query[key];
              toggleFilter(key, urlValue);
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this = this;
            return /*#__PURE__*/_react["default"].createElement(WrappedComponent
            // eslint-disable-next-line react/jsx-props-no-spreading
            , _extends({}, this.props, {
              initialValue: this.getInitialValue(),
              applyFilter: function applyFilter(value, searchNow, baseURL) {
                return _this.applyFilter(value, searchNow, baseURL);
              },
              doSearch: function doSearch() {
                return _this.doSearch();
              }
            }));
          }
        }]);
      }(_react.PureComponent), _defineProperty(_Facet, "displayName", "Facet(".concat(WrappedComponent.name, ")")), _defineProperty(_Facet, "propTypes", {
        attribute: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
        filters: _propTypes["default"].object,
        location: _propTypes["default"].object,
        push: _propTypes["default"].func.isRequired,
        toggleFilter: _propTypes["default"].func.isRequired
      }), _defineProperty(_Facet, "defaultProps", {
        attribute: [],
        filters: {},
        location: {}
      }), _Facet;
    };
  }
});